import { app } from '../../app.module'
/**
 * サブカテゴリ情報管理用のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EditSubCategoryModal(Restangular, $q) {
  /**
   * サブカテゴリを保存
   * @param categoryInfo カテゴリ情報
   * @return サーバーからの結果
   */
  function saveSubCategory(categoryInfo: {
    saveType: string
    categoryName: string
    subCategoryName: string
    beforeSaveSubCategory: string
  }) {
    const deferred = $q.defer()

    const saveUrl = '/category/saveSubCategory'

    Restangular.all(saveUrl)
      .post(categoryInfo)
      .then((result) => {
        deferred.resolve(result[0].data)
      })

    return deferred.promise
  }

  return {
    saveSubCategory: saveSubCategory,
  }
}

/**
 *  カテゴリ管理モーダル用のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} EditSubCategoryModal サブカテゴリ管理用のサービス
 * @return {Object} サービスのオブジェクト
 */
function EditSubCategoryService(EditSubCategoryModal) {
  return {
    editSubCategory: EditSubCategoryModal,
  }
}

// カテゴリ管理モーダル用のサービスを定義
app
  .factory('EditSubCategoryModal', EditSubCategoryModal)
  .factory('EditSubCategoryService', EditSubCategoryService)
